import UserAgent from './UserAgent.js';

/** bodyに"browser-is-xxx"のクラスをつける */
class BrowserClass {
  constructor() {
    this.browser = UserAgent.browser;
  }

  _addBrowserClass(className) {
    document.body.classList.add(className);
  }

  /** これを実行する */
  init() {
    if (this.browser.isIE) {
      this._addBrowserClass('browser-is-ie');
    } else if (this.browser.isLegacyEdge) {
      this._addBrowserClass('browser-is-legacy-edge');
    } else if (this.browser.isChromiumEdge) {
      this._addBrowserClass('browser-is-chromium-edge');
    } else if (this.browser.isFirefox) {
      this._addBrowserClass('browser-is-ff');
    } else if (this.browser.isChrome) {
      this._addBrowserClass('browser-is-chrome');
    } else if (this.browser.isSafari) {
      this._addBrowserClass('browser-is-safari');
    }
  }
}

export default new BrowserClass();
